import Vue from 'vue';
import { Money, Currencies } from 'ts-money';

Vue.use({
  install(vue) {
    vue.prototype.$money = Money;
    vue.prototype.$currencies = Currencies;
  },
});
